export default "__VITE_ASSET__BPI2X1fy__"